import React from 'react';
import ActiveStationStore from '../../_flux/stores/active_station_store';
import CartStore from '../../_flux/stores/cart_store';
import { handleView } from '../handle_view';
import { ProductsStore } from '../../_flux/stores/products_store';
import { FittingStationStore } from '../../_flux/stores/fitting_station_store';
import { General } from '../../_flux/stores/sidebar/general';
import { LightBox as LightBoxStore } from '../../_flux/stores/sidebar/light_box';
import { LightBox as LightBox } from '../../_flux/components/sidebar/light_box';
import { hide } from '../../_flux/actions/sidebar/light_box';
import { show as showFriendbuyLightBox } from '../../_flux/actions/friendbuy_light_box_actions';

const stores = {
    activeStationState: ActiveStationStore,
    fittingStationState: FittingStationStore,
    products: ProductsStore,
    cartState: CartStore,
    sidebar: General,
    lightBox: LightBoxStore,
};

export const render = ({ products, lightBox, cartState }, options) => (
    <LightBox
        products={window.fromTopCart ? TYROOLA.initialFluxStates.topCartProducts : products}
        currencyIsoCode={options.currencyIsoCode}
        visible={lightBox.visible}
        onClose={hide}
        onMatesRatesLearnMoreClick={showFriendbuyLightBox}
        cartProducts={cartState.cart.products}
        shipments={cartState.cart.shipments}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);
